import React from 'react';
import { useTranslation } from 'react-i18next';
import './EventCard.css';

const EventCard = ({ event, onClick }) => {
  const { t, i18n } = useTranslation();

  const getLocalized = (field, lang) => {
    if (!field || typeof field === 'string') return field;
    return field[lang] ?? field['en'] ?? '';
  };

  const isTBA = event.date === "TBA" || event.date === null || event.date === "";
  const eventDate = isTBA ? null : new Date(event.date);

  const handleKeyDown = (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className="event-card"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <div className="event-date">
        {isTBA ? (
          <>
            <div className="event-day">TBA</div>
            <div className="event-month"></div>
            <div className="event-year"></div>
          </>
        ) : (
          <>
            <div className="event-day">{eventDate.getDate()}</div>
            <div className="event-month">
              {eventDate.toLocaleDateString('en-US', { month: 'short' })}
            </div>
            <div className="event-year">
              {eventDate.getFullYear()}
            </div>
          </>
        )}
      </div>
      <div className="event-info">
        <h3 className="event-venue">{event.venue}</h3>
        <p className="event-location">{event.location}</p>
        {event.description && (
          <p className="event-description">{getLocalized(event.description, i18n.language)}</p>
        )}
        {event.detailsComingSoon && (
          <p className="event-coming-soon">{t('events.detailsComingSoon')}</p>
        )}
        {event.link && (
          <a
            href={event.link}
            target="_blank"
            rel="noopener noreferrer"
            className="event-link"
          >
            {t('events.viewOnMap')} →
          </a>
        )}
      </div>
    </div>
  );
};

export default EventCard;

